(function ($) {

    var swipers = [];
    function slider() {

        var sliders = $('.products__slider');

        if(swipers.length > 0){
            swipers.forEach((swiper) => {
                swiper.destroy()
            });
        }

        sliders.each(function (index) {

            var $slider = $(this);
            let per_view = $slider.data('per-view');
            let centered = $slider.data('centered');
            let destroy = $slider.data('destroy');
            let spaceBetween = $slider.data('space');
            let carousel = $slider.data('carousel');
            let draggable = true;
            swipers.push( new Swiper($slider.find('.swiper-container').get(0), {
                slidesPerView: per_view["m"],
                centeredSlides: centered["m"],
                spaceBetween: parseInt(spaceBetween["m"]),
                loop: carousel["m"],
                effect: 'slide',
                watchOverflow: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                threshold: 20,
                navigation: {
                    nextEl: $slider.find(".swiper-button-next").get(0),
                    prevEl: $slider.find(".swiper-button-prev").get(0),
                },
                scrollbar: {
                    el: $slider.find(".swiper-scrollbar").get(0),
                    hide: true,
                    draggable: draggable,
                },
                mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 20,
                    thresholdTime: 0.1,
                },
                breakpoints: {
                    768: {
                        slidesPerView: per_view["t"],
                        centeredSlides: centered["t"],
                        spaceBetween: parseInt(spaceBetween["t"]),
                        loop: carousel["t"],
                    },
                    1200: {
                        slidesPerView: per_view["d"],
                        centeredSlides: centered["d"],
                        spaceBetween: parseInt(spaceBetween["d"]),
                        loop: carousel["d"],
                    },
                },
                on: {
                    reachEnd: function () {
                        $slider.addClass('-end');
                    },
                    fromEdge: function () {
                        $slider.removeClass('-end');
                    },
                    slideChange: function (swiper) {
                        $(this.el).siblings('.slider__numbers').find('.slider_index').text(parseInt(this.realIndex + 1))
                        swiper.slides.removeClass('my-visible');
                        updateVisibleSlides(swiper);
                    },
                    init: function (swiper) {
                        $(this.el).siblings('.slider__numbers').find('.slider_maxIndex').text($(this.el).find('.swiper-slide:not(".swiper-slide-duplicate")').length);
                        updateVisibleSlides(swiper);
                    },
                    resize(swiper) {
                        updateVisibleSlides(swiper);
                    }
                }
            }));


            function updateVisibleSlides(swiper) {
                swiper.slides.forEach(slide => slide.classList.remove('slide-visible'));
                let count = swiper.params.slidesPerView;
                if (count === 'auto') {
                    count = 1;
                }

                for (let i = swiper.activeIndex; i < swiper.activeIndex + count; i++) {
                    if (swiper.slides[i]) {
                        swiper.slides[i].classList.add('slide-visible');
                    }
                }
            }

            $slider.swiper = swipers[swipers.length - 1];

            // Because swiper doesnt allow enable/disable autoplay on responsive and destroy
            $slider.swiper.autoplay.stop();
            if (window.innerWidth <= 767) {
                if (destroy["m"]) {
                    $slider.swiper.disable();
                } else {
                    $slider.swiper.enable();
                }
            }
            if (window.innerWidth > 767 && window.innerWidth <= 1200) {
                if (destroy["t"]) {
                    $slider.swiper.disable();
                } else {
                    $slider.swiper.enable();
                }
            }
            if (window.innerWidth > 1200) {
                if (destroy["d"]) {
                    $slider.swiper.disable();
                } else {
                    $slider.swiper.enable();
                }
            }
        });
    };

    var w = $(window).width();
    $( window ).on('resize', function() {
        if ($(window).width()==w) return;
        w = $(window).width();
        slider();
    });

    $(document).gp_ready(function(){
        slider();
    });

})(jQuery);

